import _ from 'lodash';

export default function useProtectedClickHandler(onClick, name) {
  return e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (_.get(window, 'Livewire.currentUser.id')) {
      onClick();
    } else if (name) {
      window.location = `/sign_up?return_to_section=${name}`;
    } else {
      window.location = '/sign_up';
    }
  };
}
